import {ChangeDetectionStrategy, Component, OnDestroy, OnInit, ViewEncapsulation} from '@angular/core';
import {Subject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';

import {FuseProgressBarService} from '@fuse/components/progress-bar/progress-bar.service';

@Component({
    // Angular 22 defaults to OnPush; Eager preserves the previous behaviour.
    changeDetection: ChangeDetectionStrategy.Eager,
    selector: 'fuse-progress-bar',
    templateUrl: './progress-bar.component.html',
    styleUrls: ['./progress-bar.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class FuseProgressBarComponent implements OnInit, OnDestroy {
    bufferValue: number;
    mode: 'determinate' | 'indeterminate' | 'buffer' | 'query';
    value: number;
    visible: boolean;

    // Private
    private _unsubscribeAll: Subject<void>;

    /**
     * Constructor
     *
     * @param {FuseProgressBarService} _fuseProgressBarService
     */
    constructor(private _fuseProgressBarService: FuseProgressBarService) {
        // Set the defaults

        // Set the private defaults
        this._unsubscribeAll = new Subject<void>();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
    ngOnInit(): void {
        // Subscribe to the progress bar service properties

        // Buffer value
        this._fuseProgressBarService.bufferValue.pipe(takeUntil(this._unsubscribeAll)).subscribe((bufferValue) => {
            this.bufferValue = bufferValue;
        });

        // Mode
        this._fuseProgressBarService.mode.pipe(takeUntil(this._unsubscribeAll)).subscribe((mode) => {
            this.mode = mode;
        });

        // Value
        this._fuseProgressBarService.value.pipe(takeUntil(this._unsubscribeAll)).subscribe((value) => {
            this.value = value;
        });

        // Visible
        this._fuseProgressBarService.visible.pipe(takeUntil(this._unsubscribeAll)).subscribe((visible) => {
            this.visible = visible;
        });
    }

    /**
     * On destroy
     */
    ngOnDestroy(): void {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------
}
